import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { Reveal, Overline } from "@/components/site/Reveal";

export const Fleet = () => {
  const { t } = useLang();
  return (
    <section id="fleet" className="bg-canvas py-24 md:py-32" data-testid="fleet">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal className="max-w-3xl mb-14 md:mb-20">
          <Overline>{t.fleet.overline}</Overline>
          <h2 className="mt-4 font-serif font-light text-navy text-4xl md:text-6xl tracking-tight">
            {t.fleet.title}
          </h2>
          <p className="mt-6 font-light leading-relaxed text-navy/70 max-w-xl">{t.fleet.subtitle}</p>
        </Reveal>

        <div className="grid gap-6 md:gap-8 sm:grid-cols-2">
          {t.fleet.boats.map((boat, i) => (
            <Reveal key={boat.slug} delay={i * 0.12}>
              <Link
                to={`/barca/${boat.slug}`}
                data-testid={`fleet-boat-${i}`}
                className="group block"
              >
                <div className="relative overflow-hidden border border-navy/10">
                  <img
                    src={boat.cardImg || boat.img}
                    alt={boat.name}
                    loading="lazy"
                    decoding="async"
                    className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-navy/60 via-transparent to-transparent opacity-80" />
                  <motion.span
                    className="absolute bottom-5 left-5 right-5 flex items-center justify-between text-canvas"
                  >
                    <span className="font-serif text-3xl md:text-5xl tracking-tight">{boat.name}</span>
                    <span className="text-2xl transition-transform duration-500 group-hover:translate-x-1">→</span>
                  </motion.span>
                </div>
                <p className="mt-4 text-center font-serif text-2xl md:text-3xl text-navy" data-testid={`fleet-name-${i}`}>
                  {boat.name}
                </p>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
